import { FC } from 'react';

interface LiveIndicatorProps {
  size?: 'sm' | 'md' | 'lg';
  /** Show "LIVE" label next to the dot. Used by the dashboard's
   *  RecentActivities + LeadActivity headers so both display the same
   *  pulsing dot + uppercase wordmark. */
  showLabel?: boolean;
  /** Optional className appended to the wrapper when `showLabel` is set. */
  className?: string;
}

export const LiveIndicator: FC<LiveIndicatorProps> = ({
  size = 'md',
  showLabel = false,
  className = '',
}) => {
  const outer = size === 'sm' ? 'w-4 h-4' : size === 'lg' ? 'w-7 h-7' : 'w-5 h-5';
  const inner = size === 'sm' ? 'h-2.5 w-2.5' : size === 'lg' ? 'h-4 w-4' : 'h-3 w-3';
  const dot = size === 'sm' ? 'h-1.5 w-1.5' : size === 'lg' ? 'h-2.5 w-2.5' : 'h-2 w-2';

  const dotEl = (
    <span
      className={`inline-flex items-center justify-center ${outer} rounded-full bg-gradient-to-r from-green-500/25 to-emerald-500/15 dark:from-green-500/20 dark:to-emerald-500/10 border border-green-500/50 dark:border-green-400/30 shadow-sm shadow-green-500/20 overflow-visible`}
    >
      <span className={`relative flex ${inner} items-center justify-center`}>
        <span
          className="animate-slow-ping absolute inline-flex rounded-full bg-green-400 dark:bg-green-300 opacity-60"
          style={{ width: '200%', height: '200%', top: '-50%', left: '-50%' }}
        />
        <span
          className={`relative inline-flex ${dot} rounded-full bg-green-500 dark:bg-green-400 opacity-90`}
        />
      </span>
    </span>
  );

  if (!showLabel) return dotEl;

  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[10.5px] font-bold uppercase tracking-[0.1em] text-white/80 whitespace-nowrap ${className}`}
    >
      {dotEl}
      Live
    </span>
  );
};
